import React from 'react';

import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Col, Row } from 'react-bootstrap';
import cn from 'classnames';
import CheckoutController from '../../../event_components/Checkout';
import Title from '../../../event_components/title';
import Details from '../../../event_components/details';
import AttendButton from '../../../event_components/attend_button';
import styles from './list1.scss';
import EventStatus from '../../../event_components/event_status';
import TicketPurchasing from '../../../event_components/ticket-purchasing';
import AddEventToCalendar from '../../../event_components/add_to_calendar';
import { LocaleWrapper } from '../../../../locale-wrapper';
import TwitchPreviousVideo from '../../../event_components/twitch-video';
import { attendButtonIsVisible } from '../../shared/utils';
import PaginationContainer from '../../shared/pagination_container';
import { EventTime } from '../../../event_components/event-time';
import { EventDate } from '../../../event_components/event-date';
import Gallery from '../../shared/gallery';
import { mobileLayoutComponent } from '../../shared/mobileLayoutComponent';
import { LocationItem } from '../../shared/location-item/location-item';
import DateRangeIcon from '@mui/icons-material/DateRange';
import WatchLaterSharpIcon from '@mui/icons-material/WatchLaterSharp';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export class ListEvent extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }

  toggleAttendButton = () => {
    const { event, onEventRegister } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.props.onResizeComponent();
    this.setState(
      {
        openTicketing: onEventRegister ? false : !this.state.openTicketing,
      },
      () => this.props.onResizeComponent()
    );
    onEventRegister && onEventRegister(event);
  };

  render() {
    const { event, settings, onResizeComponent, forceButtonNewRow } = this.props;
    const logo = event.getIn(['logo', 'url']);

    const hasLogo = settings.get('showEventLogo');
    if (event.get('initial_embed') || event.get('is_offline')) {
      return event.get('is_offline') ? (
        <TwitchPreviousVideo settings={settings} event={event} />
      ) : (
        <TicketPurchasing event={event} settings={settings} open onResizeComponent={onResizeComponent} />
      );
    }

    const xsLogoVisible = logo && hasLogo && event.get('type') !== 'google' && event.get('type') !== 'zoom';

    return (
      <div className={cn(styles.container, { [styles.center]: forceButtonNewRow })}>
        <Row className={cn(styles.list, 'event', { [styles.open]: this.state.openTicketing })}>
          <Col className={styles.cartWrapper}>
            <div className={cn(styles.infoWrapper, { [styles.open]: this.state.openTicketing })}>
              <Col xs={this.state.openTicketing ? null : 5} className={styles.gallery}>
                {xsLogoVisible && <Gallery event={event} />}
              </Col>

              <Col className={styles.details} xs={this.state.openTicketing ? null : 7}>
                <Title event={event} settings={settings} />
                <div className={styles.eventFactsList}>
                  <LocationItem event={event} settings={settings} className={styles.locationItem} />
                  <div className={styles.factItem}>
                    <DateRangeIcon alt="date" width="20px" className="date" />
                    <EventDate event={event} settings={settings} />
                  </div>
                  <div className={styles.factItem}>
                    <WatchLaterSharpIcon alt="time" width="20px" className="date" />
                    <EventTime event={event} settings={settings} />
                  </div>
                </div>

                {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
                {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} className={styles.addToCalendar} />}
                <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
              </Col>
            </div>
            {attendButtonIsVisible(event, settings, this.state.openTicketing) && (
              <AttendButton isFullWidth event={event} settings={settings} handleButtonClick={this.toggleAttendButton} />
            )}
          </Col>
        </Row>
        <div className={styles.checkoutWrapper}>
          <CheckoutController
            variant="redesign"
            event={event}
            settings={settings}
            inClassName="checkout-fade"
            openTicketing={this.state.openTicketing}
            onResizeComponent={onResizeComponent}
            onClose={() => {
              this.setState({
                openTicketing: false,
              });
            }}
          />
        </div>
      </div>
    );
  }
}

ListEvent.propTypes = propTypes;

export default function List1({ events, settings, isMobile, onResizeComponent, onEventRegister, forceButtonNewRow, isDatetime }) {
  const Component = isMobile ? mobileLayoutComponent(settings) : ListEvent;

  const renderEvent = (event) => (
    <LocaleWrapper event={event}>
      <Component
        key={event.get('id')}
        event={event}
        settings={settings}
        onResizeComponent={onResizeComponent}
        onEventRegister={onEventRegister}
        forceButtonNewRow={forceButtonNewRow}
        isDatetime={isDatetime}
      />
    </LocaleWrapper>
  );

  return <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />;
}

List1.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
  isDatetime: PropTypes.bool,
};
